import { z } from "zod";

export const shopSchema = z
  .object({
    shopId: z.coerce.number(),
    website: z.string(),
    locale: z.enum(["hu", "en", "de", "sk"]).catch(() => "hu" as "hu"),
    kioskSettings: z.array(z.string()),
    kioskKey: z.string(),
    email: z.string(),
    currency: z.string(),
    currencyCode: z.string().optional().nullish(),
  })
  .transform((elem) => ({
    ...elem,
    currencyCode: elem.currencyCode ?? (elem.currency === "Ft" ? "HUF" : "EUR"),
    canReturnNotes: elem.currency === "EUR",
    returnsChangeToLoggedInUser: elem.currency === "EUR",
    canGenerateInvoices: elem.currency !== "EUR",
  }));
